export const routeLoadRecoveryKey = 'dcim_route_load_recovery'

export interface RouteRecoveryStorage {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

export function isDynamicRouteLoadError(error: unknown) {
  const message = error instanceof Error ? error.message : String(error || '')
  return /Failed to fetch dynamically imported module|Unable to preload CSS|Importing a module script failed|Loading chunk .* failed/i.test(message)
}

export function claimRouteReload(storage: RouteRecoveryStorage, target: string, now = Date.now(), windowMs = 60_000) {
  try {
    const previous = JSON.parse(storage.getItem(routeLoadRecoveryKey) || 'null') as { target?: string; at?: number } | null
    if (previous?.target === target && typeof previous.at === 'number' && now-previous.at < windowMs) return false
    storage.setItem(routeLoadRecoveryKey, JSON.stringify({ target, at: now }))
    return true
  } catch {
    return false
  }
}

export function clearRouteReload(storage: RouteRecoveryStorage) {
  try { storage.removeItem(routeLoadRecoveryKey) } catch { /* Navigation remains usable without storage. */ }
}
